import { BaseModel } from "../base-model";
import { GenericBaseParameter } from "../base-parameter";
//#region list data
export interface IPersonProposalListingModel {}
export class PersonProposalListingModel
  extends BaseModel<IPersonProposalListingModel>
  implements IPersonProposalListingModel {
  constructor(option?: IPersonProposalListingModel) {
    super(option);
  }
}

//#endregion

//#region search condition
export interface IPersonProposalParameterModel {
  PersonId?: number;
}
export class PersonProposalParameterModel
  extends GenericBaseParameter<IPersonProposalParameterModel>
  implements IPersonProposalParameterModel {
  PersonId: number;
  constructor(option?: IPersonProposalParameterModel) {
    super();
    Object.keys(option).forEach(key => (this[key] = option[key]));
  }
}
//#endregion
